export function operacaoRadPesquisaPreFaturaGfoInRequest(params = {}) {
  return {
    type: '@operacaoradpesquisaprefaturagfo/RADPESQUISAPREFATURAGFO_IN_REQUEST',
    payload: { params },
  };
}

export function findOperacaoRadPesquisaPreFaturaGfo(fatu_codigo) {
  return {
    type: '@operacaoradpesquisaprefaturagfo/FIND_RADPESQUISAPREFATURAGFO',
    payload: { fatu_codigo },
  };
}

export function failedRequest() {
  return {
    type: '@operacaoradpesquisaprefaturagfo/FAILED_REQUEST',
  };
}

export function deleteOperacaoRadPesquisaPreFaturaGfo(fatu_codigo, params) {
  return {
    type: '@operacaoradpesquisaprefaturagfo/DELETE_RADPESQUISAPREFATURAGFO',
    payload: { fatu_codigo, params },
  };
}

export function updateOperacaoRadPesquisaPreFaturaGfo(operacaoradpesquisaprefaturagfo, params) {
  return {
    type: '@operacaoradpesquisaprefaturagfo/UPDATE_RADPESQUISAPREFATURAGFO',
    payload: { operacaoradpesquisaprefaturagfo, params },
  };
}

export function storeOperacaoRadPesquisaPreFaturaGfo(operacaoradpesquisaprefaturagfo, params) {
  return {
    type: '@operacaoradpesquisaprefaturagfo/STORE_RADPESQUISAPREFATURAGFO',
    payload: { operacaoradpesquisaprefaturagfo, params },
  };
}

export function successInRequest(
  operacaoradpesquisaprefaturagfo,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@operacaoradpesquisaprefaturagfo/SUCCESS_IN_REQUEST',
    payload: { operacaoradpesquisaprefaturagfo, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(operacaoradpesquisaprefaturagfo) {
  return {
    type: '@operacaoradpesquisaprefaturagfo/SUCCESS_REQUEST',
    payload: { operacaoradpesquisaprefaturagfo },
  };
}

export function successRemove(params) {
  return {
    type: '@operacaoradpesquisaprefaturagfo/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@operacaoradpesquisaprefaturagfo/RECORD_FILTERING',
    payload: { params },
  };
}
